/**
 * @Page RST01
 * @Description 완성차 재고관리 > 기준정보 > 창고등록
 **/
import React, { useState, useEffect, useRef, useCallback, useMemo } from "react";
import Ribbon from '@/components/organisms/Ribbon';
import GridRibbon from "@/components/organisms/GridRibbon";
import ContentXearch from '@/components/organisms/ContentXearch';
import Content from '@/components/organisms/Content';
import Grid from '@/components/grid/agGrid';
import CustomAlert from "@/components/molecules/CustomAlert";
import AlertDialog from '@/components/material-UI/AlertDialog';
import Popup from '@/pages/Popup/Popup';
import * as Common from '@/utils/Common';
import CommonUtil from '@/utils/CommonUtil';
import Loading from "src/components/atoms/CustomLoading2";


const SERVER_URL = process.env.REACT_APP_BACKEND_SERVER;
const Utils = new CommonUtil();
const WAREHOUSE_CODE_MAX_LENGTH = 15;

const formatPhone = value => {
    const digits = String(value ?? "").replace(/\D/g, "");
    if (digits.length === 11) return digits.replace(/(\d{3})(\d{4})(\d{4})/, "$1-$2-$3");
    if (digits.length === 10) {
        return digits.startsWith("02")
            ? digits.replace(/(\d{2})(\d{4})(\d{4})/, "$1-$2-$3")
            : digits.replace(/(\d{3})(\d{3,4})(\d{4})/, "$1-$2-$3");
    }
    if (digits.length === 9 && digits.startsWith("02")) return digits.replace(/(\d{2})(\d{3})(\d{4})/, "$1-$2-$3");
    return value ?? "";
};

const getNextAutoCode = (prefix, vendorCode, rows, field) => {
    const vendor = String(vendorCode || "").trim().toUpperCase();
    const codePattern = new RegExp(`^${prefix}_(\\d{4})_${vendor.replace(/[.*+?^${}()|[\\]\\]/g, "\\\\$&")}$`, "i");
    const maxSequence = (rows || []).reduce((max, row) => {
        const match = String(row?.[field] || "").trim().match(codePattern);
        return match ? Math.max(max, Number(match[1])) : max;
    }, 0);

    return `${prefix}_${String(maxSequence + 1).padStart(4, "0")}_${vendor}`;
};


function RST01() {

    const token = Common.getToken();
    const userId = Common.getToken("id");
    const tVnt1 = Common.getToken("vand");
    const tComp = Common.getToken("comp");
    const bigi = Common.getToken("bigi");
    const grdRST01Main = useRef();
    const grdRST01List = useRef();
    const grdRST01Detail = useRef();

    const ckVnt1 = Common.getCookie("ck_vnt1" + userId) === null || Common.getCookie("ck_vnt1" + userId) === "" || Common.getCookie("ck_vnt1" + userId) === "undefined" ? tVnt1 : Common.getCookie("ck_vnt1" + userId);
    const ckName = Common.getCookie("ck_ename") === null ? "" : Common.getCookie("ck_ename");
    const ckTelno = Common.getCookie("ck_telno") === null ? "" : Common.getCookie("ck_telno");

    let [loading, setLoading] = useState(false);

    const [residentList, setResidentList] = useState([]); // 상주원 SELECT 목록

    //Data
    const [idata, setData] = useState({
        kWrcd: "",
        kVnt1: ckVnt1,        //T1업체     
        kComp: tComp,       //회사구분
        kPlnt: "",          //공장
        kGate: "",          //하치장
        kPldt: Common.getToday(),  //소요일자
        kPtno: "",         //품번
        kCano: "",         //차량번호          
        kGubn: "N",       //미소요량 품번포함
        kName: ckName,          //담당자    
        kSttm: Common.getToday(),   //출발일자
        kSthh: Common.getHour(),    //출발시간
        kTelno: ckTelno,         //연락처   
        kEdtm: Common.getToday(),   //도착일자
        kEdhh: Common.getHour(),    //도착시간  

        dupCnt: "",    //발행매수
        chkDup: "N",    //중복발행 체크

        //코드 데이터
        vnt1List: [],  //T1업체
        plntList: [],  //공장
        gateList: [],  //하치장
        canoList: [],  //차량번호
        isToggleOn: true,
        usynList: ["Y", "N"],  //사용여부
    });


    const [message, setMessage] = React.useState({
        openAlert: false,
        severity: "success",
        msg: ""
    });
    const { openAlert, severity, msg } = message;





    const [dlgMessage, setDlgMessage] = React.useState({
        openDlg: false,
        dlgTrans: "",      // Dialog Transaction(I,U,D)
        dlgMsg: ""
    });
    const { openDlg, dlgTrans, dlgMsg } = dlgMessage;

    let [inserts, setInsert] = useState({});

    let [searchApi2, setSearchApi2] = useState(false);
    let [deleteApi2, setDeleteApi2] = useState(false);
    let [searchApi3, setSearchApi3] = useState(false);
    let [updateApi3, setUpdateApi3] = useState(false); // updateApi3 항목 setting
    let [deleteApi3, setDeleteApi3] = useState(false);
    let [clearGrid3, setClearGrid3] = useState(false);

    //추가 하위 start
    let [insertApi, setInsertApi] = useState(false);
    let [insertApi2, setInsertApi2] = useState(false);
    let [updateApi, setUpdateApi] = useState(false);
    //추가 상위 end

    const [currentWrcd, setCurrentWrcd] = useState(""); // 좌측 그리드 마지막 클릭 창고코드
    const [currentWareyn, setCurrentWareyn] = useState(""); // 선택 창고 사용여부(미사용 창고는 이력 조회만 허용)
    const [leftSelectedCount, setLeftSelectedCount] = useState(0); // 좌측 창고 체크박스 선택 건수
    const [detailSelectedCount, setDetailSelectedCount] = useState(0); // 우측 상주원 연계 선택 건수

    // 차수등록 팝업 상태
    const [ordrPopupOpen, setOrdrPopupOpen] = useState(false);
    const [ordrWrcd, setOrdrWrcd] = useState("");  // 팝업에 전달할 창고코드
    const [ordrReadOnly, setOrdrReadOnly] = useState(false); // 미사용 창고 차수는 이력 조회 전용
    const [residentPopupOpen, setResidentPopupOpen] = useState(false);
    const pendingWarehouseRows = useRef([]);

    const openNextWarehouseOrderPopup = useCallback(() => {
        const nextRow = pendingWarehouseRows.current.shift();
        if (!nextRow?.wrcd) {
            setOrdrPopupOpen(false);
            return;
        }

        setOrdrWrcd(nextRow.wrcd);
        setOrdrReadOnly(nextRow.wareyn !== "Y");
        setOrdrPopupOpen(true);
    }, []);

    const [panded, setPanded] = React.useState(true);
    // const [style, setStyle] = useState({ height :"calc(100vh - 60px - 35px - 52px - 146px - 21px - 10px)"});
    const [style, setStyle] = useState({ height: "calc(100vh - 65px - 35px - 50px - 21px - 56px - 8px )" });



    const onClearApi2 = useCallback(async (e) => {
        setSearchApi2(false);
        setDeleteApi2(false);
        setInsertApi(false);
        setInsertApi2(false);
        setUpdateApi(false);
    }, []);

    const onClearApi3 = useCallback(async (e) => {
        setSearchApi3(false);
        setUpdateApi3(false);
        setDeleteApi3(false);
        setInsertApi2(false);
    }, []);


    /**
     * 공통코드 조회 (조회조건)
     */
    const onSearchCommon = (para, name) => {
        let commonData = idata;

        const fetchData = async (para, name) => {
            let param = encodeURI(para);
            const query = SERVER_URL + "/comcd/search?query=" + param;
            await fetch(query, { headers: { Authorization: token } })
                .then((resp) => resp.json())
                .then((data) => {
                    if (data.success) {
                        commonData[name] = data.data
                        setData({ ...commonData });
                    }
                })
        }
        fetchData(para, name);
    }

    /**
     * 상주원 목록 조회 (/rst02/resi/search)
     * LEGACY: 기존에는 /rst03/wagr/search에서 창고별 품목그룹 후보를 조회했다.
     */
    const onSearchResidentList = async () => {
        let para = `{"kVnt1":"${idata.kVnt1}","useyn":"Y"}`;
        let param = encodeURI(para);
        const query = SERVER_URL + "/rst02/resi/search?query=" + param;

        return await fetch(query, { headers: { Authorization: token } })
            .then((resp) => resp.json())
            .then((data) => {
                if (data.success) {
                    const values = data.data || [];
                    setResidentList(values);
                    return values;
                }
                return [];
            })
            .catch((err) => {
                console.error("residentList 조회 실패", err);
                return [];
            });
    }



    /**
     *MOUNT 
    */
    useEffect(() => {

        //공통코드 조회 (T1업체)
        onSearchCommon(`{"pgmid":"VNT1"}`, "vnt1List");

        //납품서 발행현황조회
        onSearch2();

        // 창고 연계용 상주원 SELECT 목록 조회
        onSearchResidentList();
    }, []);


    /**
     * Control 변경 Event
     * @param {*} e 
     */
    const onChange = async (e) => {
        const { name, value } = e.target;
        let val = "";
        let newSearchs = idata;
        newSearchs[name] = value
        setData({ ...newSearchs });

    }


    //납품서 발행현황 CellValueChanged
    const grdRST01List_onCellValueChanged = async (e) => {
        if (e.colDef?.field === "wareyn" && e.data?.wrcd === currentWrcd) {
            setCurrentWareyn(e.data.wareyn || "");
        }
    }
    //납품서 상세현황 CellValueChanged
    const grdRST01Detail_onCellValueChanged = async (e) => {
        if (e.colDef?.field !== "recd") return;
        const entered = String(e.data?.recd || "").replace(/-/g, "").toUpperCase();
        const resident = residentList.find(item => String(item.recd || "").replace(/-/g, "").toUpperCase() === entered);
        if (!resident) return;
        e.node?.setDataValue("renm", resident.renm || "");
        const digits = String(resident.reph || "").replace(/\D/g, "");
        const phone = digits.length === 11 ? digits.replace(/(\d{3})(\d{4})(\d{4})/, "$1-$2-$3") : digits.length === 10 ? digits.replace(/(\d{3})(\d{3,4})(\d{4})/, "$1-$2-$3") : resident.reph || "";
        e.node?.setDataValue("reph", phone);
    }

    //납품서 발행현황 Row Click
    const grdRST01List_onRowClicked = async (e) => {
        console.log("grdRST01List_onRowClicked")
        console.log(e)
        console.log(e.data)
        // 창고코드 셀/행 클릭 시 체크박스도 같은 행으로 고정한다.
        // 이미 선택된 행은 다시 선택하지 않아 체크박스가 튕기지 않도록 한다.
        if (e.node && !e.node.isSelected()) {
            e.node.setSelected(true, false, "rowClick");
        }
        let wrcd = e.data.wrcd;
        setCurrentWrcd(wrcd); // 마지막 클릭한 창고코드 저장
        setDetailSelectedCount(0);
        setCurrentWareyn(e.data.wareyn || "");
        if (wrcd != null || wrcd != "") {
            //납품서 상세현황 조회
            onSearch3(wrcd);
        }
    }

    //납품서 발행현황 체크박스 Click
    const grdRST01List_onRowSelected = async (e) => {

        let dlno = e.data.dlno;
        if (dlno != null || dlno != "") {
            //납품서 상세현황 조회
            onSearch3(dlno);
        }
    }

    const onWarehouseRowSelected = () => {
        const selected = grdRST01List.current?.getSelectedNodes?.() || [];
        setLeftSelectedCount(selected.length);
    };

    /**
     * 검색조건
     */
    const optionsX = {
        0: [
            //회사구분
            {
                "formatter": "input", "name": "kWrcd", "labelName": "창고코드", "type": "text", "desc": "", "readOnly": false,
                "defaultValue": idata.kWrcd,
                "align": "left",
                "labelType": "none",
            },
            { "formatter": "blank", "align": "right" },
            { "formatter": "blank", "align": "right" },
            { "formatter": "blank", "align": "right" },
            { "formatter": "blank", "align": "right" },
            { "formatter": "blank", "align": "right" },
            { "formatter": "blank", "align": "right" },

        ]
    }



    /**
     * 조회 
     * @param {*} e 
     * @returns 
     */
    const onSearch = async (e) => {

        //T1업체선택 Check
        if (idata.kVnt1 == "") {
            setMessage({
                openAlert: true,
                severity: "info",
                msg: "1차업체를 선택하십시요 !"
            });
            document.getElementById("kVnt1").focus();
            return;
        }


        // Cookie 값 셋팅
        Common.setCookie("ck_vnt1" + userId, idata.kVnt1, 1);

        let para = `{"kVnt1":"${idata.kVnt1}","kComp":"${idata.kComp}","kPlnt":"${idata.kPlnt}", 
                     "kGate":"${idata.kGate}","kPtno":"${idata.kPtno}","kPldt":"${idata.kPldt}",
                     "kGubn":"${idata.kGubn}" }`;

        let param = encodeURI(para);

        const query = SERVER_URL + "RST01/search?query=" + param;
        // setSearchApi(query); // Search API

        onSearch2();//그리드2(납품서발행현황) 재조회
    }



    /**
     * 신규 Row추가
     * @param {*} e 
     */
    const onAddRow = async (e) => {
        const vendor = String(idata.kVnt1 || "").trim();
        if (!vendor) {
            setMessage({ openAlert: true, severity: "info", msg: "업체코드를 먼저 선택해 주세요." });
            return;
        }

        const wrcd = getNextAutoCode("WHS", vendor, grdRST01List.current?.getRowAllData?.(), "wrcd");
        let newItems = { vand: vendor, wrcd, wareyn: "Y", gocd: "ADD" };
        grdRST01List.current.addRow(newItems, 0);
    }
    const onSearchKeyDown = e => { if (e.key === "Enter") { e.preventDefault(); onSearch(); } };

    const onAddRow2 = async (e) => {

        if (currentWareyn !== "Y") {
            setMessage({ openAlert: true, severity: "info", msg: "미사용 창고는 과거 연계 이력만 조회할 수 있습니다." });
            return false;
        }

        if (!currentWrcd) {
            setMessage({
                openAlert: true,
                severity: "info",
                msg: "창고를 먼저 선택해 주세요."
            });
            return false;
        }
        await onSearchResidentList();
        setResidentPopupOpen(true);
    }



    /**
     * 입력 (발행)
     * @param {*} e 
     */
    const onInsert = async (e) => {

        let input = await Promise.all([inputCheck('I')]);
        if (!input[0]) return;
        pendingWarehouseRows.current = grdRST01List.current?.getSelectedData?.() || [];

        const query = SERVER_URL + "/rst01/ware/insert";
        setInsertApi(query); // Insert API

    }

    const onWarehouseInsertRefresh = async () => {
        await onSearch2();
        const rows = pendingWarehouseRows.current || [];
        pendingWarehouseRows.current = rows.filter(row => row?.gocd === "ADD" || !row?.ordr);
        grdRST01List.current?.selectRowsByCondition?.(() => false);
        if (pendingWarehouseRows.current.length > 0) {
            setDlgMessage({ openDlg: true, dlgTrans: "차수등록", dlgMsg: "창고 등록시 차수를 등록해야 사용가능합니다. 차수등록을 진행하시겠습니까?" });
        }
    };

    /**
     * 입력 (창고-상주원 연계)
     * @param {*} e 
     */
    // const onInsert2 = async (e) => {

    //     if (currentWareyn !== "Y") {
    //         setMessage({ openAlert: true, severity: "info", msg: "미사용 창고에는 상주원을 새로 연계할 수 없습니다." });
    //         return false;
    //     }

    //     // currentWrcd: 좌측 그리드에서 마지막으로 클릭한 창고코드
    //     if (currentWrcd === "" || currentWrcd == null) {
    //         setMessage({
    //             openAlert: true,
    //             severity: "info",
    //             msg: "창고를 선택해 주세요."
    //         });
    //         return false;
    //     }

    //     let selectedData = grdRST01Detail.current.getSelectedNodes();

    //     // 이미 저장된 연계 행은 체크되어 있어도 신규 등록 대상이 아니다.
    //     // 신규로 추가된 행은 Grid에서 gocd=ADD로 표시된다.
    //     const newNodes = selectedData.filter(node => node.data?.gocd === "ADD");
    //     selectedData.filter(node => node.data?.gocd !== "ADD").forEach(node => node.setSelected(false));

    //     if (newNodes.length === 0) {
    //         setMessage({ openAlert: true, severity: "info", msg: "신규로 추가된 상주원을 선택해 주세요." });
    //         return false;
    //     }

    //     selectedData = newNodes;

    //     // 선택 값 체크
    //     if (selectedData.length === 0) {
    //         //Alert 창 OPEN
    //         setMessage({
    //             openAlert: true,
    //             severity: "info",
    //             msg: "선택된 데이터가 없습니다."
    //         });
    //         return false;
    //     }

    //     let invalid = false;
    //     selectedData.forEach((node) => {
    //         if (node.data.recd == null || node.data.recd == "" || node.data.recd === undefined) {
    //             setMessage({
    //                 openAlert: true,
    //                 severity: "info",
    //                 msg: "상주원코드를 선택해 주세요."
    //             });

    //             grdRST01Detail.current.SetFocus(node.rowIndex, "recd");
    //             invalid = true;
    //         }
    //     });
    //     if (invalid) return false;

    //     // 선택된 데이터에 창고코드(wrcd) 주입
    //     selectedData.forEach((node) => {
    //         node.data.wrcd = currentWrcd;
    //     });

    //     const query = SERVER_URL + "/rst01/wareresi/insert";
    //     setInsertApi2(query); // Insert API

    // }

    /**
    * 창고 수정 
    * @param {*} e 
    * @returns 
    */
    const onUpdate = async (e) => {

        let input = await Promise.all([inputCheck('U')]);
        if (!input[0]) return;

        const query = SERVER_URL + "/rst01/ware/update";
        setUpdateApi(query); // Update API


    }

    const inputCheck = (gbn) => {

        let inputFlag = true;
        let selectedData = grdRST01List.current.getSelectedNodes();

        // 선택 값 체크
        if (selectedData.length === 0) {
            //Alert 창 OPEN
            setMessage({
                openAlert: true,
                severity: "info",
                msg: "선택된 데이터가 없습니다."
            });
            return false;
        }

        selectedData.forEach((node) => {
            if (gbn === "U") {
                if (node.data.wrcd !== node.data.wrcdOrgin) {
                    setMessage({
                        openAlert: true,
                        severity: "info",
                        msg: "창고코드는 변경불가합니다"
                    });
                    inputFlag = false
                }

                return false;
            }
            if (node.data.wrcd == null || node.data.wrcd == "" || node.data.wrcd === undefined) {
                setMessage({
                    openAlert: true,
                    severity: "info",
                    msg: "창고코드를 입력하여 주십시오."
                });

                grdRST01List.current.SetFocus(node.rowIndex, "wrcd");
                inputFlag = false
                return false;
            }
            else if (node.data.wrnm == null || node.data.wrnm == "" || node.data.wrnm === undefined) {
                setMessage({
                    openAlert: true,
                    severity: "info",
                    msg: "창고명을 입력하여 주십시오."
                });

                grdRST01List.current.SetFocus(node.rowIndex, "wrnm");
                inputFlag = false
                return false;
            }
            else if (!['Y', 'N'].includes(node.data.wareyn)) {
                setMessage({
                    openAlert: true,
                    severity: "info",
                    msg: "창고 사용여부를 선택해 주세요."
                });

                grdRST01List.current.SetFocus(node.rowIndex, "wareyn");
                inputFlag = false
                return false;
            }
        });

        return inputFlag;

    }





    /**
     * 삭제
     * @param {*} e 
     */
    const onDelete = async (e) => {
    }



    /**
     * 납품서 발행현황 조회 
     * @param {*} e 
     * @returns 
     */
    const onSearch2 = async (e) => {

        if (currentWrcd) {
            grdRST01Detail.current?.selectRowsByCondition(() => false);
        }
        setCurrentWrcd("");
        setCurrentWareyn("");
        setLeftSelectedCount(0);
        setDetailSelectedCount(0);
        setClearGrid3(true); // grid 3 초기화

        //T1업체선택 Check
        if (idata.kVnt1 == "") {
            setMessage({
                openAlert: true,
                severity: "info",
                msg: "1차업체를 선택하십시요 !"
            });
            document.getElementById("kVnt1").focus();
            return;
        }

        let para = `{"kVnt1":"${idata.kVnt1}","kWrcd":"${idata.kWrcd}"}`;
        let param = encodeURI(para);

        const query = SERVER_URL + "/rst01/ware/search?query=" + param;
        setSearchApi2(query); // Search API
    }


    /**
     * 남품서 발행현황 취소
     * @param {*} e 
     * @returns 
     */
    const onDelete2 = async (e) => {

        //select nodes
        let selectedData = grdRST01List.current.getSelectedNodes();

        // 선택 값 체크
        if (selectedData.length === 0) {
            //Alert 창 OPEN
            setMessage({
                openAlert: true,
                severity: "info",
                msg: "선택한 데이터가 없습니다."
            });
            return false;
        }

        //삭제 확인 메세지 
        setDlgMessage({
            openDlg: true,
            dlgTrans: "D2",
            dlgMsg: "선택한 창고를 삭제하시겠습니까? 과거 완성차 재고관리 및 연계 이력은 재고현황에서 보존됩니다."
        });

    }



    /**
     * 납품서 발행현황 인쇄 
     * @param {*} e 
     * @returns 
     */





    /**
     * 창고별 상주원 연계 조회
     * @param {*} wrcd
     */
    const onSearch3 = async (wrcd) => {

        let para = `{"vnt1":"${idata.kVnt1}","wrcd":"${wrcd}","useyn":"Y","_refresh":"${Date.now()}"}`;
        let param = encodeURI(para);

        const query = SERVER_URL + "/rst01/wareresi/search?query=" + param;
        setSearchApi3(query); // Search API
    }

    const onResidentInsertRefresh = async () => {
        const selected = grdRST01List.current?.getSelectedData?.() || [];
        const wrcd = selected[0]?.wrcd || currentWrcd;
        if (wrcd) {
            setCurrentWrcd(wrcd);
            await onSearch3(wrcd);
        }
    };

    /**
     * 납품서 상세현황 수정 
     * @param {*} e 
     */
    const onUpdate3 = async (e) => {

        //select nodes
        let selectedData = grdRST01Detail.current.getSelectedData();

        // 선택 값 체크
        if (selectedData.length === 0) {
            //Alert 창 OPEN
            setMessage({
                openAlert: true,
                severity: "info",
                msg: "수정할 데이터를 선택해 주세요."
            });
            return false;
        }

        const query = SERVER_URL + "/RST01/update";
        setUpdateApi3(query); // Update API
    }


    /**
     * 납품서 상세현황 납품품목삭제
     * @param {*} e 
     */
    const onDelete3 = async (e) => {

        if (currentWareyn !== "Y") {
            setMessage({ openAlert: true, severity: "info", msg: "미사용 창고의 연계 이력은 변경할 수 없습니다." });
            return false;
        }

        //select nodes
        let selectedData = grdRST01Detail.current.getSelectedNodes()
            .filter(node => String(node.data?.recd || "").trim() !== "");

        // 선택 값 체크
        if (selectedData.length === 0) {
            //Alert 창 OPEN
            setMessage({
                openAlert: true,
                severity: "info",
                msg: "선택한 데이터가 없습니다."
            });
            return false;
        }

        //삭제 확인 메세지 
        setDlgMessage({
            openDlg: true,
            dlgTrans: "D3",
            dlgMsg: "선택한 창고의 상주원 연계를 삭제하시겠습니까?"
        });

    }

    const onDetailRowSelected = () => {
        const selected = (grdRST01Detail.current?.getSelectedNodes?.() || [])
            .filter(node => String(node.data?.recd || "").trim() !== "");
        setDetailSelectedCount(selected.length);
    };


    //Transaction AlertDialogResult
    const AlertDialogResult = async (e) => {

        //AlertDialog 초기화
        setDlgMessage({ openDlg: false, dlgTrans: "", dlgMsg: "" });



        //DialogResult
        if (e.result == "N") {
            if (e.Trans === "차수등록") pendingWarehouseRows.current = [];
            return;
        }

        //Transaction 구분
        switch (e.Trans) {
            //등록
            case "개별발행":
                const query = SERVER_URL + "/RST01/singleInsert";
                // setInsertApi(query); // Insert API
                break;
            //수정
            case "U":
                break;
            //삭제
            case "D":
                //setDeleteApi(query); // Delete API
                break;
            case "D2":
                const queryD2 = SERVER_URL + "/rst01/ware/delete";
                setDeleteApi2(queryD2); // Update API
                break;
            case "D3":
                const queryD3 = SERVER_URL + "/rst01/wareresi/delete";
                setDeleteApi3(queryD3); // Delete API
                break;
            case "차수등록":
                openNextWarehouseOrderPopup();
                break;
        }
    }


    /**
     * 엑셀
     * @param {*} e 
     */
    const onExcel = async (e) => {
        let para = `{"kVnt1":"${idata.kVnt1}","kComp":"${idata.kComp}","kPlnt":"${idata.kPlnt}", 
                     "kGate":"${idata.kGate}","kPtno":"${idata.kPtno}","kPldt":"${idata.kPldt}",
                     "kGubn":"${idata.kGubn}" }`;

        let param = encodeURIComponent(para);
        const query = SERVER_URL + "/RST01/excel?query=" + param;

        setLoading(true);

        await fetch(query, { headers: { Authorization: token } })
            .then((resp) => {
                return resp.blob();
            }).then((blob) => {
                const href = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = href;
                link.setAttribute('download', 'RST01.xls');
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }).catch((err) => {
                return Promise.reject({ Error: 'error', err });
            })

        setLoading(false);
        setMessage({
            openAlert: true,
            severity: "success",
            msg: "엑셀파일이 생성되었습니다."
        });
    }


    /**
     * Grid Bind Data
     * @returns 
    */
    const onGridBindData = (para) => {
    }

    /**
     *Grid Column 정의 
    */
    //납품서 발행 Grid Column    
    const columnDefs1 = [
        { headerName: "창고코드원본", field: "wrcdOrgin", sortable: true, filter: true, flex: 1, minWidth: 60, editable: true, headerClass: "editCellOnlySub", cellClass: ["alignL"], singleClickEdit: true, hide: true, tooltipField: 'msg' },
        {
            headerName: "창고코드", field: "wrcd", sortable: true, filter: true, flex: 1, minWidth: 60,
            editable: false, headerClass: "editCellOnlySub", cellClass: ["alignL"], singleClickEdit: true,
            hide: false, tooltipField: 'msg', checkboxSelection: true, headerCheckboxSelection: true,
            
        },
        { headerName: "창고명", field: "wrnm", sortable: true, filter: true, flex: 1, minWidth: 60, editable: true, headerClass: "editCellOnlySub", cellClass: ["nocheckbox", "alignL"], singleClickEdit: true, hide: false, tooltipField: 'msg', checkboxSelection: false, headerCheckboxSelection: false },
        // { headerName: "사용여부", field: "wareyn", sortable: true, filter: true, flex: 1, minWidth: 150, editable: true, headerClass: "editCell", cellClass: ["nocheckbox", "alignC"], singleClickEdit: true, hide: false, tooltipField: 'msg' },
        {
            headerName: "사용여부", field: "wareyn", sortable: true, filter: true, flex: 1, maxLength: 5, minWidth: 100,
            editable: true, headerClass: "editCellOnlySub", cellClass: ["nocheckbox", "alignC"], singleClickEdit: true, hide: false,
            cellEditor: 'agSelectCellEditor', cellEditorParams: { values: ["Y", "N"] },
            valueFormatter: params => params.value === "Y" ? "사용" : params.value === "N" ? "미사용" : params.value ?? ""
        },
        {
            headerName: "차수", field: "ordr",
            sortable: true, filter: true, flex: 1, minWidth: 100,
            editable: false,
            headerClass: "",
            cellClass: ["nocheckbox", "alignC"],
            singleClickEdit: false, hide: false,
            cellRenderer: (params) => {
                // 신규 창고는 아직 저장되지 않았으므로 차수 등록 버튼을 표시하지 않는다.
                if (params.data?.gocd === "ADD") return null;

                const wrcd = params.data?.wrcd;
                if (!wrcd) return null;
                const orderRegistered = params.data?.ordryn === "Y";

                // 차수 미등록/등록 상태를 버튼 문구로 구분한다.
                const btn = document.createElement('button');
                btn.title = orderRegistered ? '차수 관리' : '차수 등록';
                btn.textContent = orderRegistered ? '[관리]' : '[등록하기]';
                btn.style.cssText = [
                    'background:transparent', 'cursor:pointer',
                    'padding:1px 6px', 'border:none', 'border-radius:2px', 'display:inline-flex',
                    'align-items:center', 'justify-content:center',
                    `color:${orderRegistered ? '#1976d2' : '#d06b6b'}`,
                    'font-family:inherit', 'font-size:12px', 'font-weight:500',
                    'line-height:20px', 'transition:all 0.15s ease', 'vertical-align:middle',
                    'outline:none', 'box-shadow:none'
                ].join(';');

                // 클릭 시 브라우저 기본 포커스 사각형이 잠깐 나타나지 않도록 한다.
                btn.onmousedown = (e) => e.preventDefault();

                btn.onmouseenter = () => {
                    btn.style.color = orderRegistered ? '#0d47a1' : '#ad5050';
                };
                btn.onmouseleave = () => {
                    btn.style.color = orderRegistered ? '#1976d2' : '#d06b6b';
                };

                btn.addEventListener('click', (e) => {
                    e.stopPropagation();
                    setOrdrWrcd(wrcd);
                    setOrdrReadOnly(params.data?.wareyn !== "Y");
                    setOrdrPopupOpen(true);
                });
                return btn;
            },
        },


        // { headerName: "재고조사차수", field: "etc", sortable: true, filter: true, flex: 1, minWidth: 150, editable: true, headerClass: "editCellOnlySub", cellClass: ["nocheckbox", "alignC"], singleClickEdit: true, hide: false, tooltipField: 'msg' },
    ];

    // 창고별 상주원 연계 Grid Column
    const columnDefs2 = useMemo(() => [
        {
            headerName: "상주원코드", field: "recd", sortable: true, filter: true, flex: 1, minWidth: 110,
            editable: params => currentWareyn === "Y" && params.data?.gocd === "ADD", headerClass: "editCellOnlySub", cellClass: ["nocheckbox", "alignC"],
            singleClickEdit: true, hide: false,
            cellEditor: "agSelectCellEditor",
            // 빈 항목을 첫 번째 값으로 제공해 신규 행이 목록의 첫 상주원으로 자동 대체되지 않도록 한다.
            cellEditorParams: { values: ["", ...residentList.map(item => item.recd).filter(Boolean)] },
        },
        {
            headerName: "상주원명", field: "renm", sortable: true, filter: true, flex: 1, minWidth: 110,
            editable: false, headerClass: "", cellClass: ["nocheckbox", "alignL"],
            singleClickEdit: false, hide: false,
        },
        {
            headerName: "연락처", field: "reph", sortable: true, filter: true, flex: 1, minWidth: 120,
            editable: false, headerClass: "", cellClass: ["nocheckbox", "alignC"],
            singleClickEdit: false, hide: false,
            valueFormatter: params => formatPhone(params.value),
        },
    ], [residentList, currentWareyn]);

    const onlyActiveResidentLink = useCallback(row => row?.useyn === "Y", []);


    const onClick = async (e) => {
        setPanded(!panded);


        if (panded === true) {
            setStyle({
                height: "calc(100vh - 65px - 35px - 50px - 21px - 8px )"
            });
        } else {
            setStyle({

                height: "calc(100vh - 65px - 35px - 50px - 21px - 56px - 8px )"
            });
        }

    }

    return (
        <>
            {/* Dialog FRAME */}
            <AlertDialog open={openDlg} trans={dlgTrans} message={dlgMsg} onClose={AlertDialogResult} />

            {/* Alert FRAME */}
            <CustomAlert open={openAlert} severity={severity} duration={5000} message={msg} onClose={() => { setMessage({ openAlert: false, severity: "", msg: "조회 실패" }) }} anchorOrigin={{ vertical: 'top', horizontal: 'center' }} />

            {/* Loading */}
            <Loading loading={loading} />

            {/* 차수등록 팝업 */}
            <Popup
                type={"WareOrdr"}
                open={ordrPopupOpen}
                wrcd={ordrWrcd}
                vnt1={idata.kVnt1}
                readOnly={ordrReadOnly}
                onClose={async () => {
                    setOrdrPopupOpen(false);
                    await onSearch2();
                    setTimeout(openNextWarehouseOrderPopup, 0);
                }}
            />

            <Popup
                type={"WareResi"}
                open={residentPopupOpen}
                wrcd={currentWrcd}
                vnt1={idata.kVnt1}
                onClose={(refresh) => {
                    setResidentPopupOpen(false);
                    if (refresh === true) onSearch3(currentWrcd);
                }}
            />

            {/* Ribbon Frame : 프로그램 Path 및 버튼 */}
            <Ribbon
                // onInfoMsg={"상단 그리드의 용기당수량의 빨강색표시는 <br/> 납입지시 > 기초관리 > ERP_품목관리화면의 사용자지정 용기당수량항목의 사용유무로 표출됩니다."}
                onSearch={onSearch} onSearchName={null}     //조회
            >
                {"완성차 재고관리 >기준정보 > "}<b style={{ color: "#cd5c5c", fontFamily: "PretendardMedium, NanumGothic, sans-serif" }}>창고등록</b>
            </Ribbon>


            {/* ContentXearch Frame : 검색조건 */}
            <div onKeyDown={onSearchKeyDown}><ContentXearch optionsX={optionsX} onChange={onChange} onClick={onClick} /></div>

            {/* Content FRAME (Data / Grid Frame) START -------------- */}
            <Content style={style}> {/* Content 항목에서의 100%에서 Header:60px,  Ribbon:50px,  검색조건:146px */}


                <div className="grid_type02">{/* 하단 FRAME */}
                    <div className="grid_wrap02" style={{ width: "50%", height: "100%" }}> {/* 하단 wrap 좌측 FRAME */}
                        <div className="grid_area"> {/* Grid area */}
                            <GridRibbon title={"창고등록"}
                                onSearch={onSearch} onSearchName={"조회"}
                                onUpdate={onUpdate} onUpdateName={"수정"}
                                onUpdateDisabled={leftSelectedCount === 0}
                                onDelete={onDelete2} onDeleteName={"삭제"}
                                onDeleteDisabled={leftSelectedCount === 0}
                                onInsert={onInsert} onInsertName={"입력"}
                                onInsertDisabled={leftSelectedCount === 0}
                                onAddRow={onAddRow} onAddRowName={"신규"}
                            // onPrint={(e) => { onPrintChk(e); }} onPrintName={"인쇄"}
                            // onPrintVisible={tVnt1 !== "NRAP"} tooltip={"납품서인쇄:두번 연달아 클릭하면 에러가 납니다"} 
                            >
                            </GridRibbon>
                            <div className="grid_cont_box" style={{ height: "calc(100%)" }}>

                                {/* 납품서 발행현황 Grid */}
                                <Grid
                                    ref={grdRST01List}
                                    gridId={"RST012"}                   //  (필수) Grid Id 정의
                                    columnDefs={columnDefs1}            //  (필수) 컬럼 정의 
                                    pagination={false}                  //  쪽수 매기기 여부
                                    paginationCsv={true}                //  CSV 사용구분 - pagination과 동시에 사용 필요
                                    paginationPageSize={"1000"}         //  쪽수 1Page 당 Row수
                                    rowMultiSelectWithClick={true}      //  멀티 클릭 가능 여부
                                    suppressRowClickSelection={false}    //  클릭으로 선택 하는것을 방지
                                    rowSelection={"multiple"}           //  여러개 선택 "multiple" 가능, 한개 선택할 때는 "single"
                                    enableRangeSelection={false}        //  
                                    enableCellTextSelection={true}      // cell selection drag mode
                                    isFirst={true}                      // 첫번째 컬럼 체크박스 사용여부 - ( default 체크박스 사용안함 )
                                    displayNo={true}
                                    searchApi={searchApi2}              // 조회
                                    insertApi={insertApi}
                                    updateApi={updateApi}
                                    deleteApi={deleteApi2}              // 삭제
                                    insertRefresh={onWarehouseInsertRefresh}
                                    deleteRefresh={onSearch2}           // 삭제이후 조회
                                    onClearApi={onClearApi2}            // Clear
                                    onRowClickEvent={grdRST01List_onRowClicked}
                                    onRowSelectedEvent={onWarehouseRowSelected}
                                    onCellValueChangedEvent={grdRST01List_onCellValueChanged}
                                    useMessage={false}
                                //체크박스 row click
                                // onRowSelected={grdRST01List_onRowSelected}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="grid_wrap03"> {/* 하단 wrap 우측 FRAME */}
                        <div className="grid_area"> {/* Grid area */}
                            <GridRibbon className="rst01-resident-grid-ribbon" title={currentWrcd ? `창고별 상주원 연계 [${currentWrcd}]` : "창고별 상주원 연계"}
                                // onUpdate={onUpdate3} onUpdateName={"수정"}
                                // onDelete={onDelete3} onDeleteName={"납품목록 삭제"}
                                // onSearch={onSearch} onSearchName={"조회"}
                                // onUpdate={onSearch} onUpdateName={"수정"}
                                onDelete={onDelete3} onDeleteName={"삭제"}
                                onDeleteDisabled={!currentWrcd || detailSelectedCount === 0}
                                // onInsert={onSearch} onInsertName={"입력"}
                                // onInsert={onInsert2} onInsertName={"입력"}
                            >
                                <button
                                    type="button"
                                    disabled={!currentWrcd}
                                    onClick={onAddRow2}
                                    style={{
                                        display: "flex",
                                        flexFlow: "row nowrap",
                                        justifyContent: "flex-start",
                                        alignItems: "center",
                                        height: "30px",
                                        border: "1px solid #B7BCD6",
                                        borderRadius: "2px",
                                        background: currentWrcd ? "#fff" : "#F1F2F5",
                                        color: currentWrcd ? "#222" : "#9A9A9A",
                                        marginLeft: "10px",
                                        fontWeight: 600,
                                        cursor: currentWrcd ? "pointer" : "not-allowed",
                                        paddingRight: "10px",
                                        paddingLeft: "10px",
                                        fontSize: "13px",
                                        fontFamily: "PretendardLight, NanumGothic, sans-serif",
                                    }}
                                >
                                    + 상주원 추가
                                </button>
                            </GridRibbon>
                            <div className="grid_cont_box" style={{ height: "calc(100%)" }}>

                                {/* 납품서 발행현황 Grid */}
                                <Grid
                                    ref={grdRST01Detail}
                                    gridId={"RST013"}                   //  (필수) Grid Id 정의
                                    columnDefs={columnDefs2}            //  (필수) 컬럼 정의 
                                    pagination={false}                  //  쪽수 매기기 여부
                                    paginationCsv={true}                //  CSV 사용구분 - pagination과 동시에 사용 필요
                                    paginationPageSize={"1000"}         //  쪽수 1Page 당 Row수
                                    rowMultiSelectWithClick={true}      //  멀티 클릭 가능 여부
                                    suppressRowClickSelection={false}   // 행 클릭 시 체크박스 선택
                                    rowSelection={"multiple"}           //  여러개 선택 "multiple" 가능, 한개 선택할 때는 "single"
                                    enableRangeSelection={false}        //  
                                    enableCellTextSelection={true}      // cell selection drag mode
                                    isFirst={true}                      // 첫번째 컬럼 체크박스 사용여부 - ( default 체크박스 사용안함 )
                                    displayNo={false}                 // No 컴럼 Display
                                    searchApi={searchApi3}              // 조회
                                    searchDataFilter={onlyActiveResidentLink}
                                    onClearApi={onClearApi3}            // 초기화
                                    insertApi={insertApi2}
                                    insertRefresh={onResidentInsertRefresh}
                                    updateApi={updateApi3}              // 수정
                                    deleteApi={deleteApi3}              // 삭제
                                    onCellValueChangedEvent={grdRST01Detail_onCellValueChanged}
                                    onRowSelectedEvent={onDetailRowSelected}
                                    deleteRefresh={onSearch2}           // 삭제이후 
                                    clearGrid={clearGrid3}
                                    onClearGridFlag={setClearGrid3}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </Content>
        </>
    )
}
export default RST01;
